import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStorefrontFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.0033 11.6208V21.0037V11.6208Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.0042 21.0037H1.99583H22.0042Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.99667 11.6188V21.0037V11.6188Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.49811 9.74904C7.49811 10.9922 6.49033 12 5.24718 12L7.49811 9.74904Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 9.74904C12 10.9922 10.9922 12 9.74905 12C8.50589 12 7.49811 10.9922 7.49811 9.74904",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.5019 9.74904C16.5019 10.9922 15.4941 12 14.2509 12C13.0078 12 12 10.9922 12 9.74904",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.7528 12C17.5096 12 16.5019 10.9922 16.5019 9.74904L18.7528 12Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.7528 12C19.996 12 21.0037 10.9922 21.0037 9.74904V9.62199C21.0037 9.21415 20.8928 8.814 20.6826 8.4645L18.5817 4.96805C18.2209 4.36661 17.5714 3.99804 16.87 3.99664H7.12996C6.42714 3.99664 5.77585 4.36538 5.41425 4.96805L3.31337 8.4645C3.10458 8.8144 2.99495 9.21453 2.99623 9.62199V9.74904C2.99623 10.9922 4.00402 12 5.24718 12",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0033 11.6208V21.0037M22.0042 21.0037H1.99583M3.99667 11.6188V21.0037M6.99792 21.0037V15.5015C6.99792 15.2252 7.22187 15.0012 7.49813 15.0012H9.99917C10.2754 15.0012 10.4994 15.2252 10.4994 15.5015V21.0037M14.0006 18.0025H17.0023C17.2784 18.0025 17.5023 17.7786 17.5023 17.5025V15.5012C17.5023 15.2251 17.2784 15.0012 17.0023 15.0012H14.0006C13.7245 15.0012 13.5006 15.2251 13.5006 15.5012V17.5025C13.5006 17.7786 13.7245 18.0025 14.0006 18.0025ZM7.49811 9.74904C7.49811 10.9922 6.49033 12 5.24718 12C4.00402 12 2.99623 10.9922 2.99623 9.74904V9.62199C2.99495 9.21453 3.10458 8.8144 3.31337 8.4645L5.41425 4.96805C5.77585 4.36538 6.42714 3.99664 7.12996 3.99664H16.87C17.5714 3.99804 18.2209 4.36661 18.5817 4.96805L20.6826 8.4645C20.8928 8.814 21.0037 9.21415 21.0037 9.62199V9.74904C21.0037 10.9922 19.996 12 18.7528 12C17.5096 12 16.5019 10.9922 16.5019 9.74904C16.5019 10.9922 15.4941 12 14.2509 12C13.0078 12 12 10.9922 12 9.74904C12 10.9922 10.9922 12 9.74905 12C8.50589 12 7.49811 10.9922 7.49811 9.74904Z",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgStorefrontFilled);
export default ForwardRef;
